// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"f47bc733","977":"dfe030bd"}[chunkId] + ".chunk.js";
};